(function () {
  var section     = document.querySelector(".alkatresz-kartyak");
  if (!section) return;

  var selGeptipus  = document.getElementById("al-filter-geptipus");
  var selAlkatresz = document.getElementById("al-filter-alkatresz");
  var stockBtns    = section.querySelectorAll(".al-stock-btn");
  var applyBtn     = document.getElementById("al-filter-apply");
  var clearBtn     = document.getElementById("al-filter-clear");
  var moreBtn      = document.getElementById("al-show-more");
  var items        = section.querySelectorAll(".alkatresz-kartyak__item");
  var allOptions   = selAlkatresz ? [].slice.call(selAlkatresz.querySelectorAll("option")) : [];

  var PER_PAGE  = 16;
  var showCount = PER_PAGE;
  var stockVal  = "";

  /* ---------- Géptípus -> alkatrész select szűrés ---------- */
  if (selGeptipus && selAlkatresz) {
    selGeptipus.addEventListener("change", function () {
      var chosen = selGeptipus.value;
      selAlkatresz.value = "";

      allOptions.forEach(function (opt) {
        if (!opt.value) { return; }
        var optTypes = (opt.getAttribute("data-tipus") || "").split(",");
        opt.style.display = (!chosen || optTypes.indexOf(chosen) !== -1) ? "" : "none";
      });
    });
  }

  /* ---------- Készleten gombok ---------- */
  stockBtns.forEach(function (btn) {
    btn.addEventListener("click", function () {
      stockBtns.forEach(function (b) { b.classList.remove("is-active"); });
      btn.classList.add("is-active");
      stockVal = btn.getAttribute("data-stock");
    });
  });

  /* ---------- Szűrés alkalmazása ---------- */
  function applyFilter() {
    var tipusVal    = selGeptipus ? selGeptipus.value : "";
    var alkatreszId = selAlkatresz ? selAlkatresz.value : "";
    var visibleCount = 0;
    showCount = PER_PAGE;

    items.forEach(function (item) {
      var itemTipus    = (item.getAttribute("data-tipus") || "").split(",");
      var itemKeszlet  = item.getAttribute("data-keszleten");
      var itemId       = item.getAttribute("data-id");
      var show = true;

      if (tipusVal && itemTipus.indexOf(tipusVal) === -1) show = false;
      if (alkatreszId && itemId !== alkatreszId) show = false;
      if (stockVal !== "" && itemKeszlet !== stockVal) show = false;

      if (show) {
        visibleCount++;
        item.classList.toggle("is-hidden", visibleCount > showCount);
      } else {
        item.classList.add("is-hidden");
      }
    });

    updateMoreBtn();
  }

  /* ---------- Szűrő törlése ---------- */
  function clearFilter() {
    if (selGeptipus) selGeptipus.value = "";
    if (selAlkatresz) selAlkatresz.value = "";
    stockVal = "";
    stockBtns.forEach(function (b) { b.classList.remove("is-active"); });
    if (stockBtns.length) stockBtns[0].classList.add("is-active");

    allOptions.forEach(function (opt) { opt.style.display = ""; });

    showCount = PER_PAGE;
    applyFilter();
  }

  /* ---------- További betöltése ---------- */
  function updateMoreBtn() {
    if (!moreBtn) return;
    var visibleItems = section.querySelectorAll(".alkatresz-kartyak__item:not(.is-hidden)");
    var hiddenByLimit = 0;
    items.forEach(function (item) {
      if (!item.classList.contains("is-hidden")) return;
      var tipusVal    = selGeptipus ? selGeptipus.value : "";
      var alkatreszId = selAlkatresz ? selAlkatresz.value : "";
      var itemTipus   = (item.getAttribute("data-tipus") || "").split(",");
      var itemKeszlet = item.getAttribute("data-keszleten");
      var itemId      = item.getAttribute("data-id");
      var matchFilter = true;
      if (tipusVal && itemTipus.indexOf(tipusVal) === -1) matchFilter = false;
      if (alkatreszId && itemId !== alkatreszId) matchFilter = false;
      if (stockVal !== "" && itemKeszlet !== stockVal) matchFilter = false;
      if (matchFilter) hiddenByLimit++;
    });
    moreBtn.parentElement.style.display = hiddenByLimit > 0 ? "" : "none";
  }

  if (applyBtn) applyBtn.addEventListener("click", applyFilter);
  if (clearBtn) clearBtn.addEventListener("click", clearFilter);

  if (moreBtn) {
    moreBtn.addEventListener("click", function () {
      showCount += PER_PAGE;
      applyFilter();
    });
  }

  /* ---------- Kártya kattintás -> scroll + select kitöltés ---------- */
  section.querySelectorAll(".alkatresz-kartyak__card").forEach(function (card) {
    card.addEventListener("click", function (e) {
      e.preventDefault();
      var nev = card.getAttribute("data-alkatresz-nev");
      var id  = card.getAttribute("data-alkatresz-id");
      var formSelect = document.getElementById("lead_alkatresz");
      if (formSelect && formSelect.tagName === "SELECT") {
        var opts = formSelect.options;
        for (var i = 0; i < opts.length; i++) {
          if (opts[i].value === id) {
            formSelect.value = id;
            break;
          }
        }
      } else if (formSelect) {
        formSelect.value = nev;
      }

      var target = document.getElementById("urlap-alkatresz");
      if (target) {
        target.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    });
  });

  /* ---------- Kezdeti megjelenítés ---------- */
  applyFilter();
})();
